import { render, staticRenderFns } from "./SendAgreementDialog.vue?vue&type=template&id=08bd0780&scoped=true&"
import script from "./SendAgreementDialog.vue?vue&type=script&lang=js&"
export * from "./SendAgreementDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendAgreementDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SendAgreementDialog.vue?vue&type=style&index=1&id=08bd0780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd0780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VForm,VIcon,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
